import React from 'react';
import { FlexContainer } from '../Styled/FlexContainer';
import { H2 } from '../Styled/H2';
import { H3 } from '../Styled/H3';

const Error = ({error}) => {
  return (
    <FlexContainer direction="column">
      <H2 textAlign="center">An error occured:</H2>
      <H3 textAlign="center">{error}</H3>
    </FlexContainer>
  );
}
export default Error;